<template>
  <div v-if="msg_ready">
    <feather type="info"></feather>
    <ul class="profile-dropdown onhover-show-div p-20" style="width:max-content!important;"> 
      <li v-if="!display_error">
        <div class="message-container pointer" v-for="msg in display_messages" :key="'msg_' + msg.id" @click="showMessageDetail(msg)">
          <div class="message-head">
            <div class="title">
              <div style="font-size:0.8em;">{{ msg.title }}</div>
              <span style="font-size: 0.7em;">{{ transformDate(msg.created_on) }}</span>
            </div>
            <div class="preview_badges">
              <span class="badge badge-primary">{{ ucFirst(msg.context) }}</span>
              <span class="badge badge-info" v-if="msg.priority == 'niedrig'">Information</span>
              <span class="badge badge-success" v-if="msg.priority == 'normal'">Meldung</span>
              <span class="badge badge-warning" v-if="msg.priority == 'hoch'">Wichtig</span>
            </div>
          </div>
        </div>
      </li>
      <li v-if="display_error">
        <h6>Keine Nachrichten gefunden.</h6>
      </li>
    </ul>
    <b-modal id="showBoardMessageDetailIcon" @cancel="closeModal" size="lg" ok-only>
      <div class="message-body" v-html="modal_message.body">
        {{ modal_message.body }}
      </div>
      <template slot="modal-header">
        <div class="header-with-date">
          <div class="header-title">
            <h4>{{ modal_message.title }}</h4>
            <span>{{ transformDate(modal_message.created_on) }}</span>
          </div>
          <div class="header-pills preview-badges">
            <span class="badge badge-primary" v-if="modal_message.context">{{ ucFirst(modal_message.context) }}</span>
            <span class="badge badge-info" v-if="modal_message.priority == 'niedrig'">Information</span>
            <span class="badge badge-success" v-if="modal_message.priority == 'normal'">Meldung</span>
            <span class="badge badge-warning" v-if="modal_message.priority == 'hoch'">Wichtig</span>
          </div>
        </div>
      </template>
      <template slot="modal-ok">Schließen</template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KundeBoardMessageIcon",
  data() {
    return {
      loading: true,
      ready: false,
      msg_ready: false,
      display_messages: false,
      modal_message: false,
      display_error: false,
      perPage: 3,
      currentPage: 1
    };
  },
  computed: {
    ...mapGetters({
      kunde: "auth/kou",
      animations: "app/animations",
      toasts: "app/toasts",
      wohnungen: "app/wohnungen",
      kuwo: "app/kuwo",
      readyState: "app/readyState",
      board: "msg/messages",
      allMessages: "msg/allMessages",
      boardsReady: "msg/boardsReady",
      boardUpdates: "msg/updating",
    }),
        pageCount() {
      const result = Math.ceil(this.display_messages.length / this.perPage);
      return result;
    },
    pages() {
      let runs = 0;
      let result = [];
      let pageArray = [];
      this.display_messages.forEach((msg) => {
        if (runs == this.perPage) {
          runs = 0;
          result.push(pageArray);
          pageArray = [];
          pageArray.push(msg);
        } else {
          pageArray.push(msg);
          runs++;
        }        
      });      
      result.push(pageArray);      
      return result;
    },
  },
  async created() {
    if (!this.readyState.kunde_wohnungen) {
      this.loading = true;
      try {
        await this.$store.dispatch("app/getKundeWohnungen", this.kunde.id);
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      } finally {
        this.loading = false;
      }
    }
    this.getBoardMessages();
  },
  methods: {
    
    closeModal() {
      this.$bvModal.hide("showBoardMessageDetailIcon");
      this.modal_message = false;
    },
    showMessageDetail(msg) {
      this.modal_message = msg;
      this.$bvModal.show("showBoardMessageDetailIcon");
    },
    getBoardMessages() {
      if(!this.kuwo) return;
      const kuBp = this.kuwo.map((kuwo) => {
        return kuwo.haus.haus_bp.id;
      });
      const kuHa = this.kuwo.map((kuwo) => {
        return kuwo.haus.id;
      });
      const kuWo = this.kuwo.map((kuwo) => {
        return kuwo.id;
      });

      const complete = {
        bauprojekt: [...kuBp],
        haus: [...kuHa],
        wohnung: [...kuWo],
        kunde: [this.kunde.id],
      };

      const filterMessages = this.filterMessages(complete);
      const messages = this.loadMessages(filterMessages);
      if (messages.length) {
        this.display_messages = messages;
        this.display_messages.sort(this.date_sort);
      } else {
        this.display_error = true;
      }
      
      this.msg_ready = true;
    },
    filterMessages(targets) {
      let result = [];
      const keys = Object.keys(targets);
      const len = keys.length;

      for (let a = 0; a < len; a++) {
        for (let b = 0; b < targets[keys[a]].length; b++) {
          const res = this.board[keys[a]].filter((m) => m[keys[a] + "_id"] == targets[keys[a]][b]);
          const resLength = res.length;
          if (resLength) {
            for (let c = 0; c < resLength; c++) {              
              if (result.find((val) => val.message_id == res[c].message_id) == undefined) result.push({ ...res[c], context: keys[a] });
            }
          }
        }
      }
      return result;
    },
    loadMessages(ids) {
      let result = [];
      const length = ids.length;
      for (let i = 0; i < length; i++) {
        const msg = this.allMessages.find((m) => m.id == ids[i].message_id);
        if (msg !== undefined) result.push({ ...msg, context: ids[i].context });
      }

      return result;
    },
  },
};
</script>

<style scoped>
    .preview_badges {
        display:flex;
        flex-flow:column;
        margin-left:15px;
    }

    .preview_badges .badge {
        margin-bottom:5px;
    }
</style>
